const quotesList = [
  {
    quote:
      "É muito melhor comprar uma empresa maravilhosa a um preço justo, do que uma empresa justa a um preço maravilhoso.",
    author: "Warren Buffett",
  },
  {
    quote:
      "Cuidado com as pequenas despesas; um pequeno vazamento afundará um grande navio.",
    author: "Benjamin Franklin",
  },
  {
    quote:
      "Uma jornada de mil quilômetros precisa começar com um simples passo.",
    author: "Lao Tzu",
  },
  {
    quote:
      "Temos uma quantidade enorme de conhecimento. Temos universidades pelas pontuações e centenas e milhares em todo o mundo. Mas perdemos a sabedoria, no meio de todo o nosso conhecimento.",
    author: "Billy Graham",
  },
  {
    quote: "Jamais gaste seu dinheiro antes de você possuí-lo.",
    author: "Thomas Jefferson",
  },
  {
    quote:
      "Às vezes o nosso avanço começa quando nos recusamos a ficar impressionados com o tamanho do nosso problema.",
    author: "Bill Johnson",
  },
  {
    quote:
      "Eu não estaria onde estou se eu não tivesse falhado – e muito. O bom e o ruim fazem parte da equação do sucesso.",
    author: "Mark Cuban",
  },
  {
    quote: "Investir em conhecimento sempre rende os melhores juros.",
    author: "Benjamin Franklin",
  },
  {
    quote:
      "A educação formal vai fazer você ganhar a vida. A autoeducação vai fazer você alcançar uma fortuna.",
    author: "Jim Rohn",
  },
  {
    quote:
      "Regra nº 1: nunca perca dinheiro. Regra nº 2: não se esqueça da regra nº 1.",
    author: "Warren Buffett",
  },
  {
    quote: "A marca da cultura de consumo é a redução do ‘ser’ para ‘ter’.",
    author: "John Piper",
  },
  {
    quote:
      "Compre ações impressionantes por preços que não refletem sua grandiosidade.",
    author: "Tim Hanson'",
  },
  {
    quote:
      "Seja paciente e ignore modismos. Foque no valor e não entre em pânico.",
    author: "Eddy Elfenbein",
  },
  {
    quote:
      "Menos é mais. O processo de investimento deve ser mais importante que os resultados. Comportamento correto na hora de investir é a chave.",
    author: "Ben Carlson",
  },
  {
    quote:
      "Especialistas não fazem previsões porque eles sabem o que acontecerá, mas porque são convidados.",
    author: "John Kenneth",
  },
  {
    quote:
      "Sendo devagar e constante você está disposto a trocar a oportunidade de fazer uma matança pela garantia de nunca ser morto.",
    author: "Carl Richards",
  },
  {
    quote:
      "Quando se perde a riqueza, nada se perde, quando se perde a saúde, algo se perde; quando se perde o caráter, perde-se tudo.",
    author: "Billy Graham'",
  },
  {
    quote:
      "A maioria das pessoas desiste quando elas estão próximas de alcançar o sucesso. Elas desistem a um passo da linha de chegada.",
    author: "H. Ross Perot",
  },
  {
    quote:
      "Ninguém pode prever as consequências das curiosidades e dos acidentes, e por isso, o futuro será sempre cheio de surpresas.",
    author: "Dan Gardner",
  },
  {
    quote:
      "Tempo é a vida passando que não volta mais, Perder tempo é perder vida, Deixar de avançar por causa de medo, desconfiança, covardia, complexos, acomodação é desperdiçar tempo e desperdiçar vida.",
    author: "Flávio Augusto",
  },
  {
    quote:
      "O dinheiro pode comprar uma cama muito confortável, mas o dinheiro não pode comprar o sono. Pode comprar o melhor plano de saúde, mas não a saúde.",
    author: "Flávio Augusto",
  },
  {
    quote:
      "Dê valor a sua vida, a sua família, aos seus amigos, a todos que vivem contigo.",
    author: "EMPIRE-HC",
  },
  {
    quote:
      "A vida é precária e preciosa. Não presuma que certamente amanhã você estará vivo. Não desperdice a sua vida hoje.",
    author: "John Piper",
  },
  {
    quote:
      "Desenvolva o sucesso a partir do fracasso. Desencorajamento e fracasso são dois dos mais importantes degraus na escada do sucesso.",
    author: "Dale Carnegie",
  },
  {
    quote:
      "Fracasso não é o resultado – fracassar é não tentar. Não tenha medo de falhar.",
    author: "Sara Blakely",
  },
  {
    quote:
      "Só sou rico porque sei quando estou errado. Basicamente eu sobrevivi por conseguir reconhecer os meus erros.",
    author: "George Soros",
  },
  {
    quote:
      "Se você trabalhar duro e for determinado, você alcançará seus objetivos. Eu não acredito em atalhos.",
    author: "Isabel Dos Santos",
  },
  {
    quote:
      "Você sabia que o nome Lucy foi criado em homenagem à Luz?",
    author: "Desconhecido",
  },
  {
    quote:
      "Fato curioso: Foram consumidas cerca de 500 latas de energético durante o desenvolvimento da Lucy.",
    author: "Um nerd da equipe de TI",
  },
  {
    quote:
      `Quem segura o porta-estandarte tem a arte, tem a arte E aqui passa com raça, eletrônico, o maracatu atômico`,
    author: "Chico Science & Nação Zumbi",
  },
];

export const getQuote = () => {
  return quotesList[Math.floor(Math.random() * quotesList.length)];
};
